import React from "react";
import { SearchPanelContext } from "./SearchPanel.types";

const Context = React.createContext<SearchPanelContext<any> | null>(null);

export function useSearchPanelView<T>(): SearchPanelContext<T> {
  const contextValue = React.useContext<SearchPanelContext<T>>(
    Context as unknown as React.Context<SearchPanelContext<T>>
  );
  if (!contextValue) {
    throw Error("Should be used inside the SearchPanelProvider");
  }
  return contextValue;
}

interface SearchPanelProviderProps<T> {
  value: SearchPanelContext<T>;
  children?: React.ReactNode;
}

export function SearchPanelProvider<T>(props: SearchPanelProviderProps<T>) {
  const { value, children } = props;

  return <Context.Provider value={value}>{children}</Context.Provider>;
}
